import {ID, QueryState} from '../../_metronic/helpers'
// import {User} from '../../app/modules/apps/user/users-list/core/_models'
import {DateCell} from '../cells/DateCell'
import {StatusCell} from '../cells/StatusCell'
import {fileSrc} from '../fileUtils'
import {FieldProps} from '../Form'
import {ActionsCell} from './ActionCell'
import {SelectionCell} from './SelectionCell'
import {SelectionHeader} from './SelectionHeader'
import {Thead} from './Thead'
import { UserInfoCell} from './UserInfoCell'

type Props = {
  model: string
  fields: FieldProps[]
  state: QueryState
  updateState: (state: QueryState) => void
  updateAction?: (val: any) => Promise<any>
  deleteAction?: (id: ID) => Promise<any>
  setItemIdToView: (id: ID) => void
  setItemIdForUpdate?: (id: ID) => void
  refetch?: () => void
  isAllSelected: boolean
  onSelectAll: () => void
  selected: ID[]
  onSelect: (id: ID) => void
  selectAble?: boolean
  actionAble?: boolean
  editUrl?: string
}
const getValue = (row: any, path: string): any => {
  return path
    .replace(/\[(\d+)\]/g, '.$1') // convert [0] to .0
    .split('.')
    .reduce((acc, key) => (acc ? acc[key] : undefined), row)
}

const hasBusinessInfoField = (model: string, fields: FieldProps[]) => {
  return model === 'business' && fields.some((field) => field.name === 'name' && field.table)
}
// const getTeacherFromRow = (row: any): User | undefined => {
//   const user = getValue(row, 'employee.account.user')
//   return user?.email || user?.first_name || user?.last_name ? user : undefined
// }

export const cells = (prop: Props) => {
  const res = prop.fields
    .filter((field) => {
      if (field.name === 'name') {
        return !hasBusinessInfoField(prop.model, prop.fields)
      }

      return field.table !== false
    })

    .map((field) => ({
      Header: (props: any) => (
        <Thead
          tableProps={props}
          title={field.label}
          state={prop.state}
          updateState={prop.updateState}
          sortable={field.sortable}
          sortField={field.sortField}
        />
      ),
      id: field.name,
      Cell: (props: any, val: any) => {
        const row = props.data[props.row.index]
        const value = getValue(row, field.viewName || field.name)

        return field.type === 'date' ? (
          <DateCell date={row[field.name]} />
        ) : field.type === 'switch' || field.type === 'select' ? (
          <StatusCell
            status={value}
            model={prop.model}
            setStatus={async (val) => {
              await prop.updateAction?.({id: row.id, [field.name]: val})
              prop.refetch?.()
            }}
            field={field}
          />
        ) : field.type === 'files' && value ? (
          <a
            href={fileSrc(value)}
            target='_blank'
            rel='noopener noreferrer'
            className='text-primary fw-bold'
          >
            View File
          </a>
        ) : field.type === 'user_info' ? (
          <UserInfoCell user={value} />
        ) : field.type === 'file' ? (
          <a
            href={fileSrc(value)}
            target='_blank'
            rel='noopener noreferrer'
            className='text-primary fw-bolder fs-6'
          >
            Open <i className='fa-solid fa-up-right-from-square text-primary'></i>
          </a>
        ) : (
          <>{value}</>
        )
      },
    }))

  if (prop.selectAble) {
    res.unshift({
      Header: (props: any) => (
        <SelectionHeader
          tableProps={props}
          isAllSelected={prop.isAllSelected}
          onSelectAll={prop.onSelectAll}
        />
      ),
      id: 'selection',
      Cell: ({...props}) => (
        <SelectionCell
          id={props.data[props.row.index].id}
          selected={prop.selected}
          onSelect={prop.onSelect}
        />
      ),
    })
  }
  if (prop.actionAble) {
    res.push({
      Header: (props: any) => (
        <th {...props.tableProps} className='text-end'>
          Actions
        </th>
      ),
      id: 'actions',
      Cell: ({...props}) => (
        <ActionsCell
          id={props.data[props.row.index].id}
          setItemIdToView={prop.setItemIdToView}
          setItemIdForUpdate={prop.setItemIdForUpdate}
          refetch={prop.refetch}
          deleteAction={prop.deleteAction}
          model={prop.model}
          editUrl={prop.editUrl}
        />
      ),
    })
  }
  return res
}
